export default {
	key: "termsConditions",
	basePath: "/terms_conditions",
	exclude: false,
};
